import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const Terms = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-24 pb-16 bg-secondary/30">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-16">
              <h1 className="text-4xl md:text-5xl font-bold mb-4">
                Website Terms of Use
              </h1>
            </div>
            
            <div className="prose prose-lg max-w-none">
              <h2 className="text-3xl font-bold mb-6">Introduction</h2>
            
            <p>These terms and conditions apply between you, the User of this Website (including any sub-domains, unless expressly excluded by their own terms and conditions), and 4FOX Security Limited, the owner and operator of this Website. Please read these terms and conditions carefully, as they affect your legal rights. Your agreement to comply with and be bound by these terms and conditions is deemed to occur upon your first use of the Website. If you do not agree to be bound by these terms and conditions, you should stop using the Website immediately.</p>

            <p>You must be at least 16 years of age to use this Website. By using the Website and agreeing to these terms and conditions, you represent and warrant that you are at least 16 years of age.</p>

            <h3 className="text-2xl font-bold mb-4">Intellectual property and acceptable use</h3>
            <p>All Content included on the Website, unless uploaded by Users, is the property of 4FOX Security Limited, our affiliates or other relevant third parties. By continuing to use the Website you acknowledge that such Content is protected by copyright, trademarks, database rights and other intellectual property rights.</p>

            <p>You may, for your own personal, non-commercial use only, retrieve, display and view the Content on a computer screen. You must not otherwise reproduce, modify, copy, distribute or use for commercial purposes any Content without the explicit written permission of 4FOX Security Limited.</p>

            <h3 className="text-2xl font-bold mb-4">Prohibited use</h3>
            <p>You may not use the Website for any of the following purposes:</p>
            <ul>
              <li>In any way which causes, or may cause, damage to the Website or interferes with any other person's use or enjoyment of the Website</li>
              <li>In any way which is harmful, unlawful, illegal, abusive, harassing, threatening or otherwise objectionable</li>
              <li>Making, transmitting or storing electronic copies of Content protected by copyright without the permission of the owner</li>
            </ul>

            <h3 className="text-2xl font-bold mb-4">Links to other Websites</h3>
            <p>This Website may contain links to other sites. Unless expressly stated, these sites are not under the control of 4FOX Security Limited or that of our affiliates. We assume no responsibility for the content of such Websites and disclaim liability for all forms of loss or damage arising out of the use of them.</p>

            <h3 className="text-2xl font-bold mb-4">Privacy Policy</h3>
            <p>Use of the Website is also governed by our Privacy Policy. To view the Privacy Policy, please visit our privacy policy page.</p>

            <h3 className="text-2xl font-bold mb-4">Availability of the Website and disclaimers</h3>
            <p>Any online facilities, tools, services, or information that 4FOX Security Limited makes available through the Website is provided "as is" and on an "as available" basis. We give no warranty that the Service will be free of defects and/or faults.</p>

            <p>Whilst 4FOX Security Limited uses reasonable endeavours to ensure that the Website is secure and free of errors, viruses, and other malware, we give no warranty or guaranty in that regard and all Users take responsibility for their own security.</p>

            <h3 className="text-2xl font-bold mb-4">Limitation of Liability</h3>
            <p>Nothing in these terms and conditions will limit or exclude our or your liability for death or personal injury resulting from negligence, or limit or exclude liability for fraud or fraudulent misrepresentation.</p>

            <p>To the maximum extent permitted by law, 4FOX Security Limited accepts no liability for any business losses, such as loss of profits, income, revenue, anticipated savings, business, contracts, goodwill or commercial opportunities.</p>

            <h3 className="text-2xl font-bold mb-4">General</h3>
            <p>These terms and conditions may be varied by us from time to time. Such revised terms will apply to the Website from the date of publication. Users should check the terms and conditions regularly to ensure familiarity with the then current version.</p>

            <p>These terms and conditions will be governed by and interpreted according to English law. All disputes arising under these terms and conditions will be subject to the exclusive jurisdiction of the English courts.</p>

            <h3 className="text-2xl font-bold mb-4">4FOX Security Limited Details</h3>
            <p>4FOX Security Limited is a company incorporated in England and Wales with registered company number 15272930 and whose registered office address is at T&L Business Park, Winterstoke Road, Weston-super-Mare, North Somerset, BS23 3YS, United Kingdom.</p>

            <p>You can contact 4FOX Security Limited via our contact form or email at hello@4fox.uk.</p>

            <p className="mt-8 text-sm text-muted-foreground">
              These terms were last updated in March 2025.
            </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
